<template>
  <div class="swiper test-mech-wheel">
    <div class="swiper-wrapper">

    </div>
  </div>
</template>

<script>
import Swiper from "swiper/swiper-bundle";
import {GetTestMechListIndex} from "@/api/admin/new";

export default {
  name: "",
  data() {
    return {
      dataList: [],
      swiper: null,
      imgPath: window.apiObj.apiUrl,
      // imgPath: 'http://a.com',
      testMechPaging: {
        limit: 10,
        page: 1
      },
    };
  },
  created() {
    this.creSwiper()
    this.getTestMechList();
  },
  methods: {
    //图片路径拼接
    getImgUrl(file_path) {
      return file_path ? this.imgPath + file_path : "/image/evaluationStaff/aaa.png";
    },
    // 测试班列表
    getTestMechList() {
      GetTestMechListIndex(this.testMechPaging).then(data => {
        this.testMechPaging.page++
        let list = data.data.result
        if (list) {
          if (list.items.length < this.testMechPaging.limit) {
            this.testMechPaging.page = 1
          }
          this.swiper.virtual.appendSlide(this.group(list.items, 2));
        }
      });
    },
    group(array, subGroupLength) {
      let index = 0;
      let newArray = [];
      while (index < array.length) {
        newArray.push(array.slice(index, index += subGroupLength));
      }
      return newArray;
    },
    creSwiper() {
      let _self = this
      this.$nextTick(() => {
        this.swiper = new Swiper(".test-mech-wheel", {
          direction: 'vertical',
          slidesPerView: 2,
          // spaceBetween: 10,
          // loop: true,
          allowTouchMove: false,
          autoplay: {
            delay: 10000,
          },
          on: {
            slideChange: function () {
              if (this.isEnd) {
                _self.getTestMechList()
              }
            }
          },
          virtual: {
            renderSlide: function (slide, index) {
              return `<div class="swiper-slide">
        <div class="display_wrapper">
          <div class="display_box">
            <img src="${_self.getImgUrl(slide[0].institutional_view)}" >
            <div class="mech_name">${slide[0].mechanism_fullName}</div>
          </div>
          <div class="display_box">
            <img src="${_self.getImgUrl(slide[1].institutional_view)}">
            <div class="mech_name">${slide[1].mechanism_fullName}</div>
          </div>
        </div>
      </div>`;
            },
            addSlidesAfter: 2,
          },
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.test-mech-wheel {
  width: 100%;
  height: 100%;
}

/deep/ .display_wrapper {
  display: flex;
  justify-content: space-between;
  height: 100%;

  .display_box {
    flex: 1;
    padding: 0 5px;
  }

  img {
    width: 100%;
    height: 170px;
    border-radius: 10px;
  }

  .mech_name {
    padding: 5px;
    font-size: 14px;
    text-align: center;
  }
}

.display_content {
  text-align: center;
  font-size: 14px;
}
</style>
